import './base';
import './src/captcha';
import {
  Tabs
} from './src/tabs';
import './src/hints';
import './src/validate';
import Splide from '@splidejs/splide';
import SmartPhoto from 'smartphoto';
import {
  rollup
} from './src/rollup';
import './src/fixedCart';
import {
  updateBasketFromList,
  updateBasketFromProduct
} from './src/action';
import './src/models';
import {
  initSlider
} from './src/photo-slider';
import {
  deliveryData
} from './src/product-delivery';

const pagination = document.querySelector('.photo-product__pagination');
const tabsProduct = new Tabs('.tabs--product');

tabsProduct.tabClickHandler = function () {
  rollup('.product-description__box');
};

rollup('.product-description__box');

new SmartPhoto('.js-smartphoto', {
  forceInterval: 1
});

const productSlider = new Splide('.photo-product__slider', {
  rewind: false,
  perPage: 1,
  arrows: false,
  arrowPath: 'M16.802 19.9948L31.7358 4.87181C32.8402 3.75247 32.8402 1.94248 31.7358 0.835045C30.6313 -0.284294 28.8454 -0.272386 27.7409 0.835045L10.8215 17.9705C9.75229 19.0541 9.7288 20.7926 10.7393 21.912L27.7291 39.1664C28.2814 39.7261 29.0099 40 29.7266 40C30.4433 40 31.1718 39.7261 31.724 39.1664C32.8285 38.0471 32.8285 36.2371 31.724 35.1297L16.802 19.9948Z',
  classes: {
    arrows: 'splide__arrows photo-product__arrows',
    arrow: 'splide__arrow photo-product__arrow',
    prev: 'splide__arrow--prev photo-product__arrow--prev',
    next: 'splide__arrow--next photo-product__arrow--next',
  },
  pagination: false,
  breakpoints: {
    '991': {
      arrows: true
    }
  }
});

productSlider.on('moved', function () {
  updatePagination();
});

function updatePagination() {
  if (productSlider.length > 1) {
    pagination.textContent = (productSlider.index + 1) + '/' + productSlider.length;
  }
}

var thumbnailsSlider = new Splide('.thumbnails', {
  type: 'slide',
  perMove: 1,
  fixedWidth: 44,
  isNavigation: true,
  direction: 'ttb',
  height: '260px',
  gap: '5px',
  perPage: 5,
  arrowPath: 'M16.802 19.9948L31.7358 4.87181C32.8402 3.75247 32.8402 1.94248 31.7358 0.835045C30.6313 -0.284294 28.8454 -0.272386 27.7409 0.835045L10.8215 17.9705C9.75229 19.0541 9.7288 20.7926 10.7393 21.912L27.7291 39.1664C28.2814 39.7261 29.0099 40 29.7266 40C30.4433 40 31.1718 39.7261 31.724 39.1664C32.8285 38.0471 32.8285 36.2371 31.724 35.1297L16.802 19.9948Z',
  classes: {
    arrows: 'splide__arrows thumbnails__arrows',
    arrow: 'splide__arrow thumbnails__arrow',
    prev: 'splide__arrow--prev thumbnails__arrow--prev',
    next: 'splide__arrow--next thumbnails__arrow--next',
  },
  pagination: false,
  cover: true,
  breakpoints: {
    '991': {
      destroy: true
    }
  }
});

const count = thumbnailsSlider.root.querySelectorAll('.thumbnails__slide').length;
const maxCount = thumbnailsSlider.options.perPage;

if (count <= maxCount) {
  thumbnailsSlider.root.classList.add('thumbnails--short');
}

productSlider.sync(thumbnailsSlider);
productSlider.mount();
thumbnailsSlider.mount();
updatePagination();

updateBasketFromList();
updateBasketFromProduct();

initSlider();
deliveryData.init();
